import React from "react";

// Defining a functional component named Detail, which takes exerciseDetail as props
function Detail({ exerciseDetail }) {
  // Destructuring exerciseDetail object to extract relevant information
  const { bodyPart, gifUrl, name, target, equipment } = exerciseDetail;

  // Array of extra details to display, each containing an icon and a name
  const extraDetail = [
    {
      icon: "/waist.png", // Icon for body part
      name: bodyPart, // Name of the body part
    },
    {
      icon: "/bodypart.png", // Icon for target muscle group
      name: target, // Name of the target muscle group
    },
    {
      icon: "/weight.png", // Icon for equipment
      name: equipment, // Name of the equipment
    },
  ];

  // Rendering the Detail component
  return (
    <div className="flex items-center justify-center flex-wrap my-5 mx-2">
      {/* Left side: Displaying the exercise image */}
      <div className="w-full md:w-1/2 flex items-center justify-center">
        <img
          src={gifUrl} // Source of the exercise GIF
          alt={name} // Alt text for accessibility
          className="h-[400px] rounded-md" // Styling for the image
          loading="lazy" // Lazy loading the image for better performance
        />
      </div>
      {/* Right side: Displaying exercise details */}
      <div className="flex items-start justify-start flex-col p-2 my-2 w-full md:w-1/2">
        <h1 className="text-2xl md:text-4xl font-bold capitalize">{name}</h1> {/* Displaying the exercise name */}
        {/* Description of the exercise */}
        <h3 className="my-4">
          Exercises keep you strong.
          <span style={{ textTransform: "capitalize" }}> {name}</span> is one of
          the best exercises to target your {target}. It will help you improve
          your mood and gain energy.
        </h3>
        {/* Displaying extra details with icons */}
        <div>
          {extraDetail?.map((item, index) => (
            <div
              key={index}
              className="flex items-center justify-start gap-2 my-2"
            >
              <img
                src={item?.icon} // Icon for the detail
                alt={item?.name} // Alt text for accessibility
                className="h-14 p-2 rounded-full bg-gradient-to-l from-black/20 to-red-600/20" // Styling for the icon
              />
              <span className="font-semibold capitalize">{item?.name}</span> {/* Displaying the name of the detail */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// Exporting the Detail component as the default export
export default Detail;
